import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-import-error-file',
  templateUrl: './import-error-file.component.html',
  styleUrls: ['./import-error-file.component.css'],
  standalone: false
})

export class ImportErrorFileComponent implements OnInit {

  @Input()
  title: string;
  @Input()
  data: any;
  @Input()
  dataModelList: any;

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
  }

  IsColError(value: number, errors: string): boolean {
    if (errors == undefined || errors == null)
      return false;

    return errors.split(";").includes(value.toString());
  }
}
